import React, { useState, useEffect, useRef } from "react";
import { View } from "@tarojs/components";

import "./index.scss";

export type CountdownProps = {
  expireDate: string | number;
  overTimeCb?: () => void; // 倒计时结束的回调
  customStyle?: boolean;
  isPause?: boolean; // 倒计时是否暂停
  onTimeChange?: (distance: number) => void;
};

const Countdown: React.FC<CountdownProps> = props => {
  const {
    expireDate,
    overTimeCb,
    customStyle = false,
    isPause = false,
    onTimeChange,
  } = props;
  const [hour, setHour] = useState("");
  const [min, setMin] = useState("");
  const [sec, setSec] = useState("");
  const [showTime, setShowTime] = useState(false);
  const timer = useRef<any>(null);

  let counttime: number = 0;

  const countdown = () => {
    let h;
    let m;
    let s;

    const endTime: number = new Date(expireDate).getTime();
    let nowTime = Date.now();
    const distance = endTime - nowTime;
    /** 剩余时间 */
    onTimeChange && onTimeChange(distance);

    counttime = Math.floor(distance / 1000);

    /** 截止时间过期，不展示倒计时 */
    if (counttime <= 0) {
      setShowTime(false);
      clearInterval(timer.current);
      overTimeCb?.();
      return;
    }
    setShowTime(true);

    // 秒
    s = counttime % 60;
    s = s < 10 ? "0" + s : s;
    setSec(s);
    // 分
    m = Math.floor((counttime / 60) % 60);
    m = m < 10 ? "0" + m : m;
    setMin(m);
    // 小时
    h = Math.floor(counttime / 60 / 60);
    h = h < 10 ? "0" + h : h;
    setHour(h);
  };

  useEffect(() => {
    // 调用setInterval()方法：间隔指定的毫秒数不停地执行
    clearInterval(timer.current);
    if (expireDate && !isPause) {
      timer.current = setInterval(() => {
        countdown();
      }, 1000);
    }
    return () => {
      clearInterval(timer.current);
    };
  }, [expireDate, isPause]);

  return (
    <React.Fragment>
      {showTime &&
        (customStyle ? (
          <React.Fragment>
            {hour}:{min}:{sec}
          </React.Fragment>
        ) : (
          <View className="xh-countdown">
            <View className="xh-countdown-time">{hour}</View>
            <View className="xh-countdown-dot">:</View>
            <View className="xh-countdown-time">{min}</View>
            <View className="xh-countdown-dot">:</View>
            <View className="xh-countdown-time">{sec}</View>
          </View>
        ))}
    </React.Fragment>
  );
};
export default Countdown;
